/* 
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */

import {isIdentifierLimitExceed, MAX_IDENTIFIER_SEARCH_LIMIT} from '@ion/features/src/search/utils';

/**
 * It will include global search filter with grid filter based on field and searchkeyword provided
 */
export const getSearchtFilter = (field, searchKeyword, filter) => {
  const newSearchKeyword = (field === 'id') ? `${searchKeyword}` : `*${searchKeyword}*`;
  const globalFilter = {[field]: newSearchKeyword};
  if (filter !== null) {
    return {...globalFilter, ...filter};
  }
  return globalFilter;
};

/**
 * If identifiers limit exceeded then it will trunkate the list. 
 */
export const getSearchText = (searchKeyword: string): string => {
  if (isIdentifierLimitExceed(searchKeyword)) {
    const searchList = searchKeyword.split(' ');
    return searchList.slice(0, MAX_IDENTIFIER_SEARCH_LIMIT)?.join(' ');
  }
  return searchKeyword;
};
